export const ROUTES = {
  DASHBOARD: '/dashboard',
  CREDENTIALS: '/credentials',
  AGENTS: '/agents',
  CUSTOMER_MANAGEMENT: '/customer-management',
  CHATS: '/chats',
  CONTROL_PANEL: '/control-panel',
  ANALYTICS: '/analytics',
};

export const getControlPanelThreadsPath = (chatId: string, viewOnly = true) =>
  `${ROUTES.CONTROL_PANEL}/threads/${chatId}${viewOnly ? '?viewOnly=true' : ''}`;
